function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Scooter"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.433 92.126h99.212v28.347H35.433z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.981 185.419l-14.325-64.946h19.462V92.126h-25.714l-12.505-56.693h-60.994V63.78h38.219l8.315 37.698-42.398 89.861h-25.396v-56.693H63.78c-31.311 0-56.693 25.382-56.693 56.693v28.346h28.346c0 21.26 14.173 35.433 35.433 35.433s35.433-14.173 35.433-35.433h99.212c0 19.569 15.864 35.433 35.433 35.433s35.433-15.864 35.433-35.433c.001-16.446-11.205-30.271-26.396-34.266zm-143.682 5.92H35.433c0-15.63 12.716-28.346 28.346-28.346h42.52v28.346zm85.086 0l21.039-44.592 9.836 44.592h-30.875z"
}))));